import styled, { css } from 'styled-components'
import { values, SpacingNames } from '@chegg-wt/core/theme/sunkist/spacing'
import { ButtonReset, ListReset } from '@chegg-wt/core/theme/sunkist/resets'

import { FitToContainer } from '@chegg-wt/core/theme/sunkist/sizing'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const SideBar = styled.div`
  display: flex;
  width: 200px;
  flex-direction: column;

  @media only screen and (max-width: ${({ theme }) =>
      adjust(themeBreakPoints.small(theme), -1)}) {
    display: none;
  }
`

export const Separator = styled.hr<{ separationSize?: SpacingNames }>`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  margin: ${({ separationSize = 'xsmall' }) => values[separationSize]} 0;
`

/**
 * TODO: Figure out why [1] is necessary
 * [1]: This fixes a number of alignment issues
 */
/* eslint-disable no-nested-ternary */
export const Icon = styled.span<{
  icon: string
  iconSize?: string
  iconWidth?: string
  iconHeight?: string
}>`
  display: inline-block;

  background-image: url('${({ icon }) => icon}');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  ${({ iconSize, iconWidth, iconHeight }) =>
    iconSize
      ? css`
          width: ${iconSize};
          height: ${iconSize};
        `
      : iconWidth && iconHeight
      ? css`
          width: ${iconWidth};
          height: ${iconHeight};
        `
      : css`
          width: 1em;
          height: 1em;
        `}

  /* [1] */
  &::before {
    content: '';
    display: inline-block;
  }
`

/**
 * Treat a <button /> as a container
 */
export const ButtonContainer = styled.button`
  ${ButtonReset};
`

/**
 * [1]: We want, wherever this button is inserted, the entire container to be actionable
 */
export const FullSizedAction = styled(ButtonContainer)`
  ${FitToContainer}; /* [1] */
`

export const ListContainer = styled.ul`
  ${ListReset};

  & > * + * {
    margin-top: ${values.xsmall};
  }
`
